import {exists} from 'shared/utils/custom-utils';

const onboardingLocalStorageKey = 'mvOnboardingClosed';

export function isAlreadyOnBoard(): boolean {
    return exists(localStorage.getItem(onboardingLocalStorageKey));
}

export function saveOnboardingSuccess(): void {
    localStorage.setItem(onboardingLocalStorageKey, 'true');
}